module.exports = __webpack_public_path__ + "media/customizations/delwebbfulshear/logo-da3ad8bcf8b05cbb6ae2b7723dae44d6.png";